export function serializeProductsPercentDiscount(
  discountValue,
  discountObject,
  allProducts,
  discounts
) {
  let productList = [];
  discountObject.forEach((productID) => {
    let storeProduct = allProducts.find((p) => p.id === productID);
    productList.push({
      id: storeProduct.id,
      name: storeProduct.name,
      ar_name: storeProduct.ar_name,
    });
  });
  let productsPercentsDiscount = discounts.products_percent || [];
  let discountLength = productsPercentsDiscount.length;
  if (discountLength) {
    productsPercentsDiscount.forEach((productDiscount) => {
      const lengthBefore = productDiscount.products.length;
      productDiscount.products = productDiscount.products.filter(
        (p) => !discountObject.includes(p.id)
      );
      if (lengthBefore !== productDiscount.products.length) {
        productDiscount.type = "modify";
      }
      if (productDiscount.products.length <= 0) {
        productDiscount.type = "delete";
      }
    });

    discountLength = productsPercentsDiscount.length;
  }
  productsPercentsDiscount.push({
    id:
      (discountLength && productsPercentsDiscount[discountLength - 1].id + 1) ||
      1,
    value: discountValue,
    products: productList,
    type: "add",
  });
  return productsPercentsDiscount;
}

export function serializeProductsConditionDiscounts(
  discountValue,
  discountObject,
  allProducts,
  discounts,
  type
) {
  let productList = [];
  discountObject.forEach((productID) => {
    let storeProduct = allProducts.find((p) => p.id === productID);
    if (storeProduct) {
      productList.push({
        id: storeProduct.id,
        name: storeProduct.name,
        ar_name: storeProduct.ar_name,
      });
    }
  });
  let productsPercentsDiscount = discounts[type] || [];
  let discountLength = productsPercentsDiscount.length;
  if (discountLength) {
    productsPercentsDiscount.forEach((productDiscount) => {
      const lengthBefore = productDiscount.products.length;
      productDiscount.products = productDiscount.products.filter(
        (p) => !discountObject.includes(p.id)
      );
      if (lengthBefore !== productDiscount.products.length) {
        productDiscount.type = "modify";
      }
      if (productDiscount.products.length <= 0) {
        productDiscount.type = "delete";
      }
    });

    discountLength = productsPercentsDiscount.length;
  }
  if (productList.length > 0)
    productsPercentsDiscount.push({
      id:
        (discountLength &&
          productsPercentsDiscount[discountLength - 1].id + 1) ||
        1,
      value: discountValue,
      products: productList,
      type: "add",
    });
  return productsPercentsDiscount;
} ///////

export function serializeCategoryConditionDiscount(
  discountValue,
  discountObject,
  categories,
  discounts,
  type
) {
  let categoryList = [];
  discountObject.forEach((categoryID) => {
    let storeCategory = categories.find((c) => c.id === categoryID);
    if (storeCategory) {
      categoryList.push({
        id: storeCategory.id,
        name: storeCategory.name,
        ar_name: storeCategory.ar_name,
      });
    }
  });
  let categoriesDiscount = discounts[type] || [];

  let discountLength = categoriesDiscount.length;

  if (discountLength) {
    categoriesDiscount.forEach((categoryDiscount) => {
      const lengthBefore = categoryDiscount.categories.length;
      categoryDiscount.categories = categoryDiscount.categories.filter(
        (c) => !discountObject.includes(c.id)
      );
      if (lengthBefore !== categoryDiscount.categories.length) {
        categoryDiscount.type = "modify";
      }
      if (categoryDiscount.categories.length <= 0) {
        categoryDiscount.type = "delete";
      }
    });

    discountLength = categoriesDiscount.length;
  }
  if (categoryList.length > 0)
    categoriesDiscount.push({
      id:
        (discountLength && categoriesDiscount[discountLength - 1].id + 1) || 1,
      value: discountValue,
      categories: categoryList,
      type: "add",
    });
  return categoriesDiscount;
}

export function serializeModifierstDiscount(
  discountValue,
  discountObject,
  modifiers,
  discounts
) {
  let modifierList = [];
  discountObject.forEach((modifierId) => {
    let storeModifier = modifiers.find((p) => p.id === modifierId);
    if (storeModifier)
      modifierList.push({
        id: storeModifier.id,
        value: storeModifier.value,
        ar_value: storeModifier.ar_value,
      });
  });
  let modifiersDiscount = discounts.modifier || [];
  let discountLength = modifiersDiscount.length;
  if (discountLength) {
    modifiersDiscount.forEach((modifierDiscount) => {
      const lengthBefore = modifierDiscount.modifiers.length;
      modifierDiscount.modifiers = modifierDiscount.modifiers.filter(
        (p) => !discountObject.includes(p.id)
      );
      if (lengthBefore !== modifierDiscount.modifiers.length) {
        modifierDiscount.type = "modify";
      }
      if (modifierDiscount.modifiers.length <= 0) {
        modifierDiscount.type = "delete";
      }
    });

    discountLength = modifiersDiscount.length;
  }
  if (modifierList.length > 0)
    modifiersDiscount.push({
      id: (discountLength && modifiersDiscount[discountLength - 1].id + 1) || 1,
      value: discountValue,
      modifiers: modifierList,
      type: "add",
    });
  return modifiersDiscount;
}

export function getDiscountsText(discounts, props) {
  const { settings, t, config } = props;
  const currency =
    config.language === "arabic"
      ? settings.currency_local
      : settings.currency_english;
  let discountsText = [];
  if (discounts.fixed && discounts.fixed.type !== "delete") {
    discountsText.push({
      type: "fixed",
      text: `${discounts.fixed?.value} ${currency} ${t("off")}`,
    });
  }
  if (discounts.percent && discounts.percent.type !== "delete") {
    discountsText.push({
      type: "percent",
      text: `${discounts.percent?.value} % ${t("off")}`,
    });
  }
  if (discounts.products) {
    discounts.products.forEach((product) => {
      if (product.type !== "delete") {
        discountsText.push({
          type: "products",
          text: `${t("Gets")} ${product.quantity} × ${
            config.language === "arabic"
              ? product.ar_name || product.name
              : product.name
          }`,
          id: product.id,
        });
      }
    });
  }
  if (discounts.delivery && discounts.delivery.type !== "delete") {
    discountsText.push({
      type: "delivery",
      text: `${t("Free delivery")}`,
    });
  }
  if (discounts.category) {
    discounts.category.forEach((discount) => {
      if (discount.type !== "delete") {
        discountsText.push({
          id: discount.id,
          type: "category",
          text: `${discount.value} % ${t("off")} ${discount.categories.map(
            (category) =>
              config.language === "arabic"
                ? category.ar_name || category.name
                : category.name
          )}`,
        });
      }
    });
  }
  if (discounts.category_free) {
    discounts.category_free.forEach((discount) => {
      if (discount.type !== "delete") {
        discountsText.push({
          id: discount.id,
          type: "category_free",
          text: `${discount.value} ${t(
            "free products from"
          )} ${discount.categories.map((category) =>
            config.language === "arabic"
              ? category.ar_name || category.name
              : category.name
          )}`,
        });
      }
    });
  }

  if (discounts.products_percent) {
    discounts.products_percent.forEach((discount) => {
      if (discount.type !== "delete") {
        discountsText.push({
          id: discount.id,
          type: "products_percent",
          text: `${discount.value} % ${t("off")} ${discount.products.map(
            (product) =>
              config.language === "arabic"
                ? product.ar_name || product.name
                : product.name
          )}`,
        });
      }
    });
  }

  if (discounts.modifier) {
    discounts.modifier.forEach((discount) => {
      if (discount.type !== "delete") {
        discountsText.push({
          id: discount.id,
          type: "modifier",
          text: `${discount.value} % ${t("off")} ${discount.modifiers.map(
            (modifier) =>
              config.language === "arabic"
                ? modifier.ar_value || modifier.value
                : modifier.value
          )}`,
        });
      }
    });
  }
  if (
    discounts.cashback_percent &&
    discounts.cashback_percent.type !== "delete"
  ) {
    discountsText.push({
      type: "cashback_percent",
      text: `${discounts.cashback_percent.value} % ${t(
        "of the order's total"
      )} ${t("added to wallet")}`,
    });
  }

  if (discounts.cashback_fixed && discounts.cashback_fixed.type !== "delete") {
    discountsText.push({
      type: "cashback_fixed",
      text: `${discounts.cashback_fixed.value} ${currency}  ${t(
        "added to wallet"
      )}`,
    });
  }

  if (
    discounts.delivery_percent &&
    discounts.delivery_percent.type !== "delete"
  ) {
    discountsText.push({
      type: "delivery_percent",
      text: `${discounts.delivery_percent.value} % ${t("off delivery charge")}`,
    });
  }

  return discountsText;
}
